import type { Permission, PermissionItem, PermissionType, ProjectNames } from '../types';
import type { RootState } from 'store/reducers';

const isPermissionTypesAllowed = (permissionList?: Partial<PermissionItem>, name?: Permission, type?: keyof PermissionType) => {
    if (permissionList && name && name in permissionList) {
        const permissionTypesList = permissionList[name];

        if (permissionTypesList) {
            return type ? !!permissionTypesList[type] : false;
        }
    }
    return false;
};

const projectNameCache = new Map<number, ProjectNames>();

const getProjectNameHeader = (projectId?: number): Record<string, string> => {
    if (projectId && projectNameCache.has(projectId)) {
        return { project_name: projectNameCache.get(projectId)! };
    }

    if (projectId) {
        const appState = JSON.parse(localStorage.getItem('appState')!) as RootState;
        const projectsList = appState.generalData.projectsList;

        const projectName = projectsList.find((project: { id: number }) => project.id === projectId)?.system_name;

        if (projectName) {
            projectNameCache.set(projectId, projectName);
            return { project_name: projectName };
        }
    }

    return {};
};

export { isPermissionTypesAllowed, getProjectNameHeader, projectNameCache };
